<template>
    <!--课程介绍 课程目录 - 开始-->
    <div class="mains w1195">
        <!--左边内容 - 开始-->
        <div class="mleft">
            <div class="mleft-title">
                <a href="javascript:void(0);" v-on:click="loading = true"
                   v-bind:class="loading ?  'borbot': ''">课程介绍</a>
                <a href="javascript:void(0);" v-on:click="loading = false"
                   v-bind:class="loading ?  '': 'borbot'">课程目录</a>
            </div>
            <div class="cournav">
                <!--课程介绍-->
                <div v-show="loading">
                    <img class="course-banner" :src="work.imgkcjs" style="float:none;">
                </div>
                <!--课程目录-->
                <div v-show="!loading">
                    <img class="course-banner" :src="work.imgkcml" style="float:none;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Courseinformation",
        props: ['work'],
        data() {
            return {
                loading: true,
            }
        }
    }
</script>

<style>
    /*!*课程介绍 课程目录 - 开始*!*/

    .mains {
        margin-top: 20px !important;
    }

    /*!*左边内容 - 开始*!*/

    .mleft {
        width: 890px;
        background: #fff;
    }

    .mleft-title {
        height: 52px;
        line-height: 52px;
        font-size: 0;
        border-bottom: 1px solid #dfe3e5;
    }

    .mleft .mleft-title a {
        display: inline-block;
        word-spacing: 0;
        width: 158px;
        text-align: center;
        font-size: 18px;
    }

    .mleft .mleft-title a.borbot {
        border-bottom: 2px solid #299be4;
        position: relative;
        bottom: 0
    }
</style>